document.addEventListener("DOMContentLoaded", function () {
  const zoomElements = document.querySelectorAll(".zoom-in");
  const textElements = document.querySelectorAll(".shuffle-word");
  const mosaicElements = document.querySelectorAll(".mosaic");

  // シャッフル関数
  const shuffleText = (el, duration = 800) => {
    const originalText = el.getAttribute("data-text");
    const textLength = originalText.length;
    let counter = 0;
    const intervalTime = 100;
    let shuffledText = Array.from(originalText);

    const interval = setInterval(() => {
      const index = Math.floor(counter / intervalTime);
      if (index < textLength) {
        const randomIndex = Math.floor(Math.random() * textLength);
        [shuffledText[index], shuffledText[randomIndex]] = [shuffledText[randomIndex], shuffledText[index]];
        el.textContent = shuffledText.join("");
      }

      counter += intervalTime;
      if (counter >= duration) {
        clearInterval(interval);
        el.textContent = originalText;
      }
    }, intervalTime);
  };

  // モザイク効果
  const applyMosaicEffect = (el) => {
    el.style.transition = 'opacity 1s ease-in-out';
    el.style.opacity = '0';
    setTimeout(() => {
      el.style.opacity = '1';
      el.classList.add("mosaic-effect"); // Apply the class to trigger mosaic effect
    }, 100); // Delay for smooth effect
  };

  // スクロールやインタラクションを監視してズームやシャッフル、モザイクを適用
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains("zoom-in")) {
          entry.target.classList.add("active");
        } else if (entry.target.classList.contains("shuffle-word")) {
          entry.target.classList.add("visible");
          shuffleText(entry.target);
        } else if (entry.target.classList.contains("mosaic")) {
          applyMosaicEffect(entry.target);
        }
        observer.unobserve(entry.target);
      }
    });
  });

  zoomElements.forEach((el) => observer.observe(el));
  textElements.forEach((el) => observer.observe(el));
  mosaicElements.forEach((el) => observer.observe(el));

  const video = document.getElementById("introVideo");
  const loadingScreen = document.getElementById("loadingScreen");
  const mainContent = document.getElementById("mainContent");
  const body = document.body;

    // 初回訪問かどうかをチェック
    if (!sessionStorage.getItem("visited")) {
        // 初回訪問ならローディング画面を表示してスクロール禁止
        body.classList.add("no-scroll");

        function showMainContent() {
            loadingScreen.style.display = "none";
            mainContent.style.display = "block";
            body.classList.remove("no-scroll"); // スクロールを許可
            sessionStorage.setItem("visited", "true"); // 訪問記録を保存
        }

        // 動画が終了したらメインコンテンツを表示
        video.addEventListener("ended", showMainContent);

        // 万が一動画が再生されなかった場合、5秒後にページを表示
        setTimeout(() => {
            if (loadingScreen.style.display !== "none") {
                showMainContent();
            }
        }, 5000);
    } else {
        // 2回目以降はローディング画面をスキップ
        loadingScreen.style.display = "none";
        mainContent.style.display = "block";
    }  
});

document.addEventListener('contextmenu', function (e) {
  e.preventDefault();
});
